import React, {  useState } from 'react';
import "./SignIn.css";
import { useNavigate } from 'react-router-dom';
import img from "../../assets/Frame 18140610.png";
import axios from 'axios';
import { baseUrl } from '../../common/baseUrl';
import axiosInstance from '../../axiosInstance/axiosInstance';
import { clearRedirectPath, getRedirectPath } from '../../common/redirectPath';


export default function SignIn({userId,is_contact_verified,contact}) {

  // console.log("User Id :",userId)

  const navigate = useNavigate();
  // const location = useLocation();

  const [inputs, setInputs] = useState({ name: "", email: "" });
  const [errors, setErrors] = useState({ name: "", email: "" });
  const [isFormValid, setIsFormValid] = useState(false);


  // Validate Name
  const validateName = (name) => {
    try{
      const errors = { name: "" };
      if (name.trim()==="") {
        errors.name = "Please Enter Your Name";
      }
      else if (!/^[A-Za-z ]+$/.test(name)) {
        errors.name = "Name Can Only Contain Alphabets";
      }
      return errors;

    }catch(error){
      console.log(error);
    }
  };

  // Validate Email
  const validateEmail = (email) => {
    try{

      const errors = { email: "" };
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.email = "Please Enter Valid Email";
      }
      return errors;
    
    }catch(error){
      console.log(error);
    }
  };

  // useLocation Hook used for getting the token and user_id
  // const token = location.state?.token || "";
  // const contact = location.state?.contact || "";
  // const is_contact_verified = location.state?.is_contact_verified || false;



  // Navigate to Create Profile if we don't get token and user id
  // if (token === "" || contact === "" || is_contact_verified===false) {
  //   navigate("/createProfile");
  // }

  
    // Set User Id Here
    // const { users_id } = useParams();
    // console.log(users_id);


  // Handle Change
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const updatedInputs = { ...inputs, [name]: value };
    setInputs(updatedInputs);

    let validationErrors = {};
    if (name === "name") {
      validationErrors = validateName(value);
    } else if (name === "email") {
      validationErrors = validateEmail(value);
    }
    const updatedErrors = { ...errors, ...validationErrors };
    setErrors(updatedErrors);
    setIsFormValid(
      updatedInputs.name.trim() !== "" &&
      Object.values(updatedErrors).every(error => error === "")
    );
  };


  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return null; // if cookie not found
  }


  // Submission for the form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) {
      // console.log("Form has errors:", errors);
      return;
    }

    let is_email_verified = true;
    if(inputs.email===""){
      is_email_verified = false;
    }

    try {
      const formData = {
        ...inputs,
        verification_id: "",
        contact: contact,
        is_contact_verified: is_contact_verified,
        is_email_verified: is_email_verified,
      };

      // console.log("Form data in Sign In Page:", formData);
      const response = await axiosInstance.put(
        `/api/v1/users/${userId}`,
        formData
      );

      // console.log("Response:", response.data);

      // Setting Up The userName in the cookie
      localStorage.setItem("userName",inputs.name)

      // Came in from a link we sent them, so send them back to it
      const redirectPath = getRedirectPath();
      if(redirectPath){
        clearRedirectPath();
        navigate(redirectPath);
        return;
      }

      const hotelId = getCookie("hotelId");
      const tableId = getCookie("tableId");
      if(hotelId && tableId){
        navigate(`/hotels/${hotelId}/table/${tableId}`);
        return;
      }




      // Navigate to booking over here
      navigate("/bookings",{
          state : {
            activeTab : "Ongoing"
          }
        });

      
      setInputs({ name: "", email: "" }); //Clear Inputs
      setErrors({ name: "", email: "" }); // Clear errors on successful submission
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form id="signInForm" autoComplete="off" method='PUT' onSubmit={handleSubmit}>
      <div className="signin-profile-main">
        <div className="signin1">
          {/* Image Part */}
          <div className="signin1-img">
            <img src={img} alt="error" />
          </div>

          {/* Account Details */}
          <div className="signin1-account">
            <div className="signin1-header">
              <h3>Create Profile</h3>
            </div>
            <div className="signin1-desc">
              <p>Please enter your details to help us communicate better</p>
            </div>

            <div className="signin1-inp">
              {/* Input field for signin */}
              <div className="signin1-inputs">
                {/* Name */}
                <div className="signin-input">
                  <div className="signin-label">
                    <label htmlFor="name">Enter Name</label>
                  </div>
                  <div className="signin-inp">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Enter Name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                    />
                    {/* Placeholder for error message */}
                    <div className="error-message">{errors.name}</div>
                  </div>
                </div>

                {/* Email */}
                <div className="signin-input">
                  <div className="signin-label">
                    <label htmlFor="email">Enter Email (Optional)</label>
                  </div>
                  <div className="signin-inp">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter Email"
                      value={inputs.email || ""}
                      onChange={handleChange}
                    />
                    {/* Placeholder for error message */}
                    <div className="error-message">{errors.email}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="signin2-btn">
          <button type="submit" disabled={!isFormValid}>Continue</button>
        </div>
      </div>
    </form>
  );
}
